<template>
  <main id="more_body">
    <top-menu :top_title="top_title"></top-menu>
    <div class="div_padding"></div>
    <div class="wrapper">
      <div class="main_text_box">
        <h3>즐거움과 혜택이 더해지는</h3>
        <h3>커뮤니티 플랫폼 <span id="thehae">더해</span></h3>
      </div>
      <div class="icon_menu">
        <div class="icon" id="more_icon">
          <div>
            <div class="img"><img onclick="location_invite();" src="images/basic/icon/more-invite.svg" alt="" /></div>
            <p onclick="location_invite();">친구초대</p>
          </div>
          <div class="">
            <div class="img"><img onclick="location_event();" src="images/basic/icon/more-event.svg" alt="" /></div>
            <p onclick="location_event();">이벤트</p>
          </div>
          <!--          <div class="new">-->
          <!--            <div class="img"><img onclick="location_order_list();" src="images/basic/icon/more-delivery.svg" alt=""></div>-->
          <!--            <p onclick="location_order_list();">주문내역 <span>1</span></p>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <div class="img"><img onclick="location_rank();" src="images/basic/icon/more-ranking.svg" alt=""></div>-->
          <!--            <p onclick="location_rank();">랭킹</p>-->
          <!--          </div>-->

          <div class="">
            <div class="img"><img onclick="location_notice();" src="images/basic/icon/more-notice.svg" alt="" /></div>
            <p onclick="location_notice();">공지사항</p>
          </div>
          <div class="">
            <div class="img"><img onclick="location_help();" src="images/basic/icon/more-help.svg" alt="" /></div>
            <p onclick="location_help();">도움말</p>
          </div>
          <div>
            <div class="img" onclick="location.href = 'https://pf.kakao.com/_Txcabs/chat';"><img src="images/basic/icon/more-qna.svg" alt="" /></div>
            <p>문의하기</p>
            <!-- onclick="location_faq();" -->
          </div>
          <div style="display: none">
            <div class="img" @click="moveToSettingForm"><img src="images/basic/icon/more-setting.svg" alt="" /></div>
            <p>환경설정</p>
          </div>
        </div>
      </div>

      <div class="menus">
        <table id="ver">
          <tr>
            <th>앱버전</th>
            <td>ver.{{ app_ver }}</td>
          </tr>
          <tr @click="goToTermsList">
            <th>약관 및 정책</th>
            <td><img src="images/basic/icon/arrow-right-thin.svg" alt="" /></td>
          </tr>
          <tr @click="goToRegPartner">
            <th>제휴 문의</th>
            <td><img src="images/basic/icon/arrow-right-thin.svg" alt="" /></td>
          </tr>
        </table>
      </div>

      <span class="co_info">Copyright THEHAE by Chainfarm. All Rights Reserved.</span>

      <div class="footer_div">
        <sns-logo-list></sns-logo-list>
      </div>
    </div>
    <bottom-menu></bottom-menu>
  </main>
</template>

<script>
import { fetchMainCommonInfo } from "@/api/info";
import TopMenu from "@/components/common/TopMenu";
import BottomMenu from "@/components/common/BottomMenu";
import SnsLogoList from "@/components/common/SnsLogoList";
export default {
  components: {
    TopMenu,
    BottomMenu,
    SnsLogoList,
  },
  created() {
    window.VueRoot=this;
    fetchMainCommonInfo().then(({ data }) => {
      this.snsList = data.result.snsList;
    });
  },
  mounted() {
    document.getElementById("icon_more").src = "images/basic/menu_icon/tabbar-themore-on.svg";
  },
  data() {
    return {
      snsList: [],
      //app_ver: "1.0.0",
      top_title: '<span id="top_title">더해볼것</span>',
    };
  },
  computed: {
    app_ver(){
      return this.$store.state.appVersion;
    },
  },
  methods: {
    moveToSettingForm() {
      this.$router.push("/setting");
    },
    goToTermsList() {
      this.$router.push("/termsList");
    },
    goToRegPartner() {
      this.$router.push("/partnershipInquiry");
    },
  },
};
</script>

<style scoped>
main {
  height: 100vh;
}
</style>
